import { render, staticRenderFns } from "./h1.vue?vue&type=template&id=42b644f4&"
import script from "./h1.vue?vue&type=script&lang=js&"
export * from "./h1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports